import React from 'react';

import type { RegisseurType } from '@/types';

type RegisseurContextType = {
  // Régisseur connecté
  regisseur: RegisseurType;
};

const RegieContext = React.createContext<RegisseurContextType>({
  regisseur: null,
});

export default RegieContext;
